export const FRANCE_COUNTRY_CODE = 'FR';
